import {
	PUT_WORK_CENTER,
	PUT_WORK_CENTER_ERROR,
	PUT_WORK_CENTER_SUCCESS,
} from '../../../constants';

export const putStatusWorkCenterReducer = (state, actions) => {
	switch (actions.type) {
		case PUT_WORK_CENTER:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case PUT_WORK_CENTER_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case PUT_WORK_CENTER_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				workCenters: actions.payload,
			};
		default:
			return state;
	}
};
